<template>
  <v-container class="px-0 my-3">
    <v-row class="d-flex flex-wrap justify-content-start">
      <v-col cols="12" class="text-center">
        <h1>Departamentos</h1>
      </v-col>
      <v-col class="v-col-12 v-col-md-6 v-col-lg-3 px-6 px-lg-2" v-for="(t, index) in getCategoriesLimit()" v-bind:key="index">
        <v-card class="card-categories">
          <v-card-text class="d-flex flex-column align-items-start">
            <a @click="$router.push('/feed/'+t.id)" class="text-color-1 text-menu font-weight-bold cursor-pointer">{{ capitalize(t.name) }}</a>
            <div class="mt-3 w-100 d-flex flex-column h-100" v-if="t.subcategories && t.subcategories.length > 0">
              <a @click="$router.push('/feed/'+t.id+'/'+ts.id_subcategoria)" v-for="ts in t.subcategories" v-bind:key="ts.id_subcategoria" class="w-100 py-1 link-menu">{{ capitalize(ts.nome_subcategoria) }}</a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { capitalize } from '@/store/services/utils.js';
export default {
  name: 'Categorias',
  computed: {
    ...mapGetters('main', {
      getCategoriesLimit: 'getCategoriesLimit'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      getSubCategories: 'getSubCategories'
    }),
    capitalize
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        this.getCategoriesLimit().forEach(element => {
          this.getSubCategories(element.id);
        });
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function () {
      this.$router.push('/');
    }.bind(this));
  }
}
</script>